import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-my-grants-filter',
  templateUrl: './my-grants-filter.component.html',
  styleUrls: ['./my-grants-filter.component.scss'],
  standalone: false,
})
export class MyGrantsFilterComponent {
  @Input() disabled = false;
  @Input() toggleState = false;

  @Output() toggleFilter = new EventEmitter();

  public tooltipMessage =
    'My Grants is a feature that allows you to view only the most important grants for you to track.';

  public toggleChange(): void {
    this.toggleFilter.emit(this.toggleState);
  }
}
